import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SwitchListItem from '../../../../../list-items/SwitchListItem/SwitchListItem';
import CreatePageConstants from '../../../CreatePageConstants';
import * as PIXI from 'pixi.js';

const BackdropFilterListItem = (props) => {
    const { backgroundFilterEnabled, updateBackgroundSettings } = props;
    const onFilterChange = (event) => updateBackgroundSettings({ filterEnabled: event.target.checked });

    return (
        <SwitchListItem
            text='Filter'
            checked={backgroundFilterEnabled}
            onChange={onFilterChange}
            toolTip='Background will apply a vignette and increase contrast during loud audio when this is enabled.'
            warning={PIXI.utils.isWebGLSupported() ? null : CreatePageConstants.LIMITED_VISIBILITY_WARNING_TEXT}
        />
    );
};

const mapStateToProps = (state) => {
    const { filterEnabled: backgroundFilterEnabled } = state.createPreview.present.videoSettings.background;
    return { backgroundFilterEnabled }
}

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackdropFilterListItem);